"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useFetchedData;
exports.usePromise = usePromise;
// Universal data fetcher/processor to replace the various data-fetching hooks, I hope
const react_1 = __importDefault(require("react"));
const page_data_utils_1 = require("./page-data-utils");
function useFetchedData(_a, defaultValue) {
    var { resolveTo = 'json' } = _a, options = __rest(_a, ["resolveTo"]);
    const slug = options.slug;
    const slugPromise = react_1.default.useMemo(() => {
        if (!slug) {
            return null;
        }
        return new Promise((resolve) => (0, page_data_utils_1.getUrlFor)(slug).then((url) => fetch(url).then(resolve)));
    }, [slug]);
    const url = options.url;
    const urlPromise = react_1.default.useMemo(() => {
        if (!url) {
            return null;
        }
        return fetch(url);
    }, [url]);
    const promiseOption = options
        .promise;
    const promise = react_1.default.useMemo(() => { var _a; return (_a = slugPromise !== null && slugPromise !== void 0 ? slugPromise : urlPromise) !== null && _a !== void 0 ? _a : promiseOption; }, [slugPromise, urlPromise, promiseOption]);
    const processedPromise = react_1.default.useMemo(() => promise ? promise.then((resp) => resp[resolveTo]())
        .then((rawData) => processRawData(rawData, options))
        : Promise.resolve(defaultValue), [promise, resolveTo] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return usePromise(processedPromise, defaultValue);
}
// This is a common pattern. Should be used throughout the codebase
function usePromise(promise, defaultValue) {
    const [data, setData] = react_1.default.useState(defaultValue);
    react_1.default.useEffect(() => {
        promise.then(setData);
    }, [promise]);
    return data;
}
function processRawData(rawData, processing) {
    let returnValue = rawData;
    if (processing.transform) {
        // mutates
        (0, page_data_utils_1.transformData)(rawData);
    }
    if (processing.camelCase) {
        returnValue = (0, page_data_utils_1.camelCaseKeys)(rawData);
    }
    if (processing.postProcess) {
        returnValue = returnValue.map(processing.postProcess);
    }
    return returnValue;
}
